import React from "react";
import { useGlobalCtx } from "../../../Context/GlobalContext";

const ARCSHeader = React.lazy(() => import("../../../Themes/arcs/markup/header"));
const DisneyHeader = React.lazy(() => import("../../../Themes/disney/markup/header"));
const MMRCICHeader = React.lazy(() => import("../../../Themes/mmr-cic/markup/header"));
const MMRMARSHeader = React.lazy(() => import("../../../Themes/mmr-mars/markup/header"));
const BlinkHeader = React.lazy(() => import('../../../Themes/insightspace/markup/header'));
const ParadoxHeader = React.lazy(() => import('../../../Themes/paradox/markup/header'));
const UofPennHeader = React.lazy(() => import('../../../Themes/penn/markup/header'));
const BethesdaHeader = React.lazy(() => import('../../../Themes/bethesda/markup/header'));
const ActivisionHeader = React.lazy(() => import("../../../Themes/activision/markup/header"));
const VerizonHeader = React.lazy(() => import("../../../Themes/verizon/markup/header"));
const EAHeader = React.lazy(() => import("../../../Themes/ea/markup/header"));
const NRGHeader = React.lazy(() => import("../../../Themes/nrg/markup/header"));
const CRGHeader = React.lazy(() => import("../../../Themes/crg/markup/header"));
const BlizzardHeader = React.lazy(() => import("../../../Themes/blizzard/markup/header"));
const BungieHeader = React.lazy(() => import("../../../Themes/bungie/markup/header"));
const OpinlyHeader = React.lazy(() => import("../../../Themes/opinly/markup/header"));
const SpencerHeader = React.lazy(() => import("../../../Themes/spencer/markup/header"));
const BurtsBeesHeader = React.lazy(() => import("../../../Themes/burtsbees/markup/header"));
const GreatLakesHeader = React.lazy(() => import('../../../Themes/greatlakes/markup/header'));
const BHVRHeader = React.lazy(() => import('../../../Themes/bhvr/markup/header'));
const BootsHeader = React.lazy(() => import('../../../Themes/boots/markup/header'));
const No7Header = React.lazy(() => import('../../../Themes/no7/markup/header'));
const KingHeader = React.lazy(() => import("../../../Themes/king/markup/header"));
const KynetecHeader = React.lazy(() => import("../../../Themes/kynetec/markup/header"));
const PinPointHeader = React.lazy(() => import("../../../Themes/pinpoint/markup/header"));
const InsightsCentersHeader = React.lazy(() => import("../../../Themes/insightscenters/markup/header"));
const BrightsideHeader = React.lazy(() => import('../../../Themes/brightside/markup/header'));
const BrightsideVoicesHeader = React.lazy(() => import('../../../Themes/brightside-voices/markup/header'));
const NoThemeHeader = React.lazy(() => import('../../../Themes/notheme/markup/header'));
const BlinkuxHeader = React.lazy(() => import('../../../Themes/blinkux/markup/header'));
const CustomHeader = React.lazy(() => import('../../../Themes/custom/markup/header'));
const TbsoHeader = React.lazy(() => import('../../../Themes/tbso/markup/header'));
const PupHeader = React.lazy(() => import('../../../Themes/pup/markup/header'));

export default function Header() {
  const globalCtx = useGlobalCtx();
  let component = null;
  switch (globalCtx.Theme.toLocaleLowerCase()) {
    case "arcs":
      component = <ARCSHeader />;
      break;
    case "activision":
      component = <ActivisionHeader />;
      break;
    case "mmr-cic":
      component = <MMRCICHeader />;
      break;
    case "mmr-mars":
      component = <MMRMARSHeader />;
      break;
    case "bethesda":
      component = <BethesdaHeader />;
      break;
    case "paradox":
      component = <ParadoxHeader />;
      break;
    case "penn":
      component = <UofPennHeader />;
      break;
    case "nrg":
      component = <NRGHeader />;
      break;
    case "crg":
      component = <CRGHeader />;
      break;
    case "disney":
      component = <DisneyHeader />;
      break;
    case "blink":
    case 'insightspace':
      component = <BlinkHeader />;
      break;
    case "ea":
    case 'ea-cte':
      component = <EAHeader />;
      break;
    case "verizon":
      component = <VerizonHeader />;
      break;
    case "blizzard":
      component = <BlizzardHeader />;
      break;
    case "bungie":
      component = <BungieHeader />;
      break;
    case "king":
      component = <KingHeader />;
      break;
    case "kynetec":
      component = <KynetecHeader />;
      break;
    case "opinly":
      component = <OpinlyHeader />;
      break;
    case "spencer":
      component = <SpencerHeader />;
      break;
    case "burtsbees":
      component = <BurtsBeesHeader />;
      break;
    case "greatlakes":
      component = <GreatLakesHeader />;
      break;
    case 'behaviourinteractive':
    case 'bhvr':
      component = <BHVRHeader />;
      break;
    case 'boots':
    case 'boots-uk':
      component = <BootsHeader />;
      break;
    case 'no7':
    case 'boots-us':
      component = <No7Header />;
      break;
    case "pinpoint":
      component = <PinPointHeader />;
      break;
    case "insightscenters":
      component = <InsightsCentersHeader />;
      break;
    case "brightside":
      component = <BrightsideHeader />;
      break;
    case "brightside-voices":
      component = <BrightsideVoicesHeader />;
      break;
    case "notheme":
      component = <NoThemeHeader />;
      break;
    case 'blinkux':
      component = <BlinkuxHeader />;
      break;
    case 'tbso':
      component = <TbsoHeader />;
      break;
    case 'pup':
      component = <PupHeader />;
      break;
    default:
      if (globalCtx.isResourcesLoaded)
        component = <CustomHeader />;
  }
  return (
    <>
      {(globalCtx.StudyId > 0 || globalCtx.StudyIdentifier !== '') && globalCtx.LangResources === null ? (<div className="min-h-20"></div>) :
        (
          <React.Suspense>
            {component}
          </React.Suspense>
        )}
    </>
  )
}
